import styled from '@emotion/styled';
import { ReactComponent as SpinnerSVG } from '../../../assets/spinner.svg';

const SpinnerContainer = styled.div`
  display: flex;
  justify-content: center;
`;

const Spinner = () => {
  return (
    <SpinnerContainer>
      <div style={{ width: 64 }}>
        <SpinnerSVG width="100%" />
      </div>
    </SpinnerContainer>
  );
};

export default Spinner;
